/* OBC — Variantify compatibility shim.

   Variantify picks the collection wrap with querySelector() over a list that
   contains BOTH '.collection__products' (an ancestor) and
   '.collection__products > .grid' (the real parent of the cards). Document
   order makes it pick the ancestor, so its
     wrap.insertBefore(clone, card)
   throws NotFoundError because `card` is not a child of `wrap` — and the app
   dies before inserting a single colourway tile.

   Two fixes below:
   1. insertBefore fallback — if the reference node is not a child of `this`,
      insert into the reference node's real parent instead. Only fires in the
      exact case that would otherwise throw.
   2. Legacy class names, because their title/image selectors no longer match
      this theme.

   DELETE THIS FILE once Variantify ship a proper fix. */
(function () {
  /* --- 1. insertBefore fallback --- */
  var nativeInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, refNode) {
    if (refNode && refNode.parentNode && refNode.parentNode !== this) {
      try {
        return nativeInsertBefore.call(refNode.parentNode, newNode, refNode);
      } catch (e) {
        return nativeInsertBefore.call(this, newNode, refNode);
      }
    }
    return nativeInsertBefore.call(this, newNode, refNode);
  };

  /* --- 2. legacy class names --- */
  var TITLE_SRC = '.product-grid-item__title';
  var TITLE_ADD = 'grid-product__title';
  var IMG_SRC = '.product__media__container img';
  var IMG_ADD = 'productitem--image-primary';

  function tag() {
    var i, els;
    els = document.querySelectorAll(TITLE_SRC);
    for (i = 0; i < els.length; i++) { els[i].classList.add(TITLE_ADD); }
    els = document.querySelectorAll(IMG_SRC);
    for (i = 0; i < els.length; i++) { els[i].classList.add(IMG_ADD); }
  }

  var pending = false;
  function schedule() {
    if (pending) { return; }
    pending = true;
    setTimeout(function () { pending = false; tag(); }, 16);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tag);
  } else {
    tag();
  }
  window.addEventListener('load', tag);
  var delays = [150, 500, 1200, 2500];
  for (var d = 0; d < delays.length; d++) { setTimeout(tag, delays[d]); }

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
